document.addEventListener('click', (event) => {
  const option = event.target.closest('.kh-language__option[name="language_code"]');
  if (!option) return;
  const form = option.closest('form');
  const localeCode = option.value;
  if (!form || !localeCode) return;
  event.preventDefault();
  let localeInput = form.querySelector('input[name="locale_code"]');
  if (!localeInput) {
    localeInput = document.createElement('input');
    localeInput.type = 'hidden';
    localeInput.name = 'locale_code';
    form.appendChild(localeInput);
  }
  if (localeInput.value === localeCode) return;
  localeInput.value = localeCode;
  form.submit();
});
